// extracted by mini-css-extract-plugin
export var bg = "index-module--bg--4bxvn";
export var cls1 = "index-module--cls1--V7B3q";
export var cls2 = "index-module--cls2--9tXBH";
export var cls3 = "index-module--cls3--+br5f";
export var crossIcon = "index-module--crossIcon--Iiajt";
export var left = "index-module--left--w4gy6";